export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/proofreading_editing.b890e60.svg";